import { useState } from 'react';
import { PageShell } from './PageShell.js';
import { Worker } from '../sections/Worker.js';
import { submitWaitlist, waitlistErrorCode } from '../api/waitlist.js';
import type { FormState } from './HomePage.js';
import type { WashedLocale } from '@washed/i18n';

interface PageProps {
  locale: WashedLocale;
  onLocaleChange: (locale: WashedLocale) => void;
}

const TITLE: Record<WashedLocale, string> = {
  fr: 'Devenir laveuse Washed à Lomé — travail rémunéré',
  en: 'Become a Washed washerwoman in Lomé — paid work',
};

export function WorkerPage({ locale, onLocaleChange }: PageProps) {
  const [state, setState] = useState<FormState>({ kind: 'idle' });

  const handleSubmit = async (input: {
    name: string;
    phone: string;
    quartier: string;
    email?: string;
    source: 'worker';
    consentTerms: boolean;
    cfTurnstileResponse?: string;
  }) => {
    setState({ kind: 'loading' });
    try {
      const res = await submitWaitlist({ ...input, audience: 'worker', locale });
      setState({ kind: 'success', position: res.position, alreadyListed: res.alreadyListed });
    } catch (e) {
      setState({ kind: 'error', code: waitlistErrorCode(e) });
    }
  };

  return (
    <PageShell
      locale={locale}
      onLocaleChange={onLocaleChange}
      title={TITLE[locale]}
      heroHeader={false}
      cta={false}
    >
      <Worker locale={locale} onSubmit={handleSubmit} state={state} />
    </PageShell>
  );
}
